export default "__VITE_ASSET__Bs9ues$a__"